module.exports = __webpack_public_path__ + "img/iconJiaYouShenQing.46302bb7.svg";